export enum DocumentPublicationFlowState {
  ForApproval = 1,
  OpenChangeRequest = 2,
  UnderRevision = 3,
  Rejected = 4,
}
